module.exports = __webpack_public_path__ + "img/plebianj.dbdb2ce8.jpg";